import { useLayoutContext } from '../../../context/LayoutContext'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSun, faMoon } from '@fortawesome/free-solid-svg-icons'

export const ThemeToggler = () => {
  const { toggleTheme } = useLayoutContext()

  return (
    <div className="topbar-item d-none d-sm-flex">
      <button className="topbar-link" id="light-dark-mode" type="button" onClick={toggleTheme}>
        <span className="mode-light-moon">
          <FontAwesomeIcon icon={faMoon} />
        </span>
        <span className="mode-light-sun">
          <FontAwesomeIcon icon={faSun} />
        </span>
      </button>
    </div>
  )
}
